import React, { useState, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import {  injectIntl } from "react-intl";


import ThemeRow from "../../../components/scheduleRows/themerow";
import ArchiveHeader from "../../../components/ArchiveHeader";
import PageLoading from "../../../components/Loading";


import CreateItemForm from '../../../components/CreateItemForm'
import Table from '../../../components/TableNew';

import Alert from "react-s-alert";
import { useQuery, useMutation, queryCache } from "react-query";

import { getSchedule, deleteSchedule } from '../schedules/xhr';

const Themes = ({ intl, locale, setLocale }) => {
  const [search, setSearch] = useState("");
  const [themeName, setThemeName] = useState('')

  const { isLoading, isError, error, data: schedule } = useQuery('schedule', getSchedule, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [deleteThemeMutation] = useMutation(deleteSchedule, {
    onSuccess: (deletedTheme) => {
      if(queryCache.getQueryData('schedule')) {
          queryCache.setQueryData('schedule', schedule => ({
            ...schedule,
            colors: schedule.colors.filter(c => c._id !== deletedTheme._id)
          }))
      }
      Alert.success(intl.formatMessage({ id: 'color.delete-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  // React.useEffect(() => {
  //   if(schedule.length === 0) {
  //     scheduleItemsFetch();
  //   }
  // }, [scheduleItemsFetch, schedule]);

  const columns = useMemo(
    () => [
      {
        Header: "Themes",
        accessor: ({ _id, ...row }) => {
          return Object.values(row).join("|");
        },
        Cell: ({ cell: { value }, row: { original } }) => (
          // <pre>{JSON.stringify(original, null, 2)}</pre>
          <ThemeRow
            key={original._id}
            id={original._id}
            name={original.name}
            color={original.color}
            deleteFn={(collection,_id) => {
              deleteThemeMutation({collection, _id })
            }}
          />
        ),
      },
    ],
    [deleteThemeMutation]
  );

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }



  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="tab.schedule-colors" />
      <div className="pad-2rem">
        <Container fluid>
          <Row className="align-items-center m-b-20">
            <Col lg={6}>
              <CreateItemForm
                heading="button.s.color-create"
                setFunc={setThemeName}
                placeholder={intl.formatMessage({ id: 'button.s.color-create' })}
                link={`/themes/add/${themeName}`}
              />
            </Col>
            <Col lg={6}>
              <Row>
                <Col></Col>
                <Col md={5}>
                  <div className="text-right search-container">
                    <FormGroup>
                      <InputGroup onChange={(e) => setSearch(e.target.value)}>
                        <FormControl type="text" />
                        <InputGroup.Append>
                          <Button>
                            <img src="/icons/search.png" alt="plus" />
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table columns={columns} data={schedule.colors} search={search} intl={intl} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

// const mapStateToProps = (state) => ({
//   userProfile: state.user.profile,
// });

// const mapDispatchToProps = dispatch => {
//   return {
//     scheduleItemsFetch: () => dispatch(scheduleItemsFetch()),
//     scheduleItemCud: (collection, action, id, data) =>
//       dispatch(scheduleItemCud(collection, action, id, data)),
//     dispatch
//   };
// };

export default injectIntl(Themes);
